import React from 'react';
import { CellText, CheckboxInput as BaseCheckboxInput } from '@increasecard/typed-components';
import styled from 'styled-components';

export type CalendarToggleVariant = 'light' | 'dark30';
export interface CalendarToggleProps {
  checked: boolean;
  description?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  id: string;
  name: string;
  label: string;
  variant: CalendarToggleVariant;
}

const Label = styled.label<Pick<CalendarToggleProps, 'variant'>>`
  ${({ theme }) => theme.typography.H3}
  font-weight: bold;
  width: 100%;
  padding: 8px;
  display: inline-flex;
  align-items: center;
  color: ${({ theme, variant }) =>
    variant === 'light' ? theme.colorsNew.product.dark70 : theme.colorsNew.gray.white};
  background: ${({ theme, variant }) =>
    variant === 'light' ? theme.colorsNew.product.light : theme.colorsNew.product.dark30};
`;

const Description = styled(CellText)`
  padding: 0 16px;
  margin-top: 4px;
  color: ${({ theme }) => theme.colorsNew.gray.blackSLight};
`;

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

const CheckboxInput = styled(BaseCheckboxInput)<Pick<CalendarToggleProps, 'variant'>>`
  --background-color: ${({ theme, variant }) =>
    variant === 'dark30' ? theme.colorsNew.gray.white : theme.colorsNew.product.dark70};
  --fill-color: ${({ theme, variant }) =>
    variant === 'dark30' ? theme.colorsNew.product.dark30 : theme.colorsNew.product.light};

  margin-right: 8px;
`;

export function CalendarToggle({ label, description, variant, ...rest }: CalendarToggleProps) {
  return (
    <Wrapper>
      <Label variant={variant}>
        <CheckboxInput variant={variant} {...rest} /> {label}
      </Label>
      <Description>{description}</Description>
    </Wrapper>
  );
}
